import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getLeagueTypeForDL,
  getPath,
  getTranslations,
  isAndroid,
  isIOS,
} from "../../../Common/utils";
import { CtaButton } from "../../../ReusableComponents";
import useDataLayer from "../../../Common/hooks/useDataLayer";
import {
  FANTASY_ANDROID,
  FANTASY_IOS,
  FANTASY_WEBSITE,
  WEB,
  WEBVIEW,
} from "../../../Common/constants";
import useTournamentScanario from "../../../Common/hooks/useTournamentScanario";

const CreateLeague = () => {
  const navigate = useNavigate();
  const { isEos, lastGamedayRaceLocked } = useTournamentScanario();
  const disableCTAs = isEos || lastGamedayRaceLocked;

  const translationState = useSelector((state) => state.translation);
  const userState = useSelector((state) => state.user);

  const pushToDataLayer = useDataLayer();

  const webview = userState?.webview;

  const pushCreateLeagueDataLayer = () => {
    const dataLayerObject = {
      actionType: "Create League",
      clickText: getTranslations(
        "league_landing_create_league_cta",
        "Create League"
      ),
      path: "/leagues",
      pageName: "Leagues",
      leagueType: getLeagueTypeForDL(),
      platform: isAndroid()
        ? FANTASY_ANDROID
        : isIOS()
        ? FANTASY_IOS
        : FANTASY_WEBSITE,
      componentType: webview ? WEBVIEW : WEB,
    };

    pushToDataLayer("navigation_click", dataLayerObject);
  };

  const handleClick = () => {
    pushCreateLeagueDataLayer();
    navigate(getPath(translationState, "createLeague"));
  };

  return (
      <CtaButton
        variant={"primaryDark"}
        icon="f1i-add"
        disabled={disableCTAs}
        onClick={() => handleClick()}
      >
        {getTranslations("league_landing_create_league_cta", "Create League")}
      </CtaButton>
  );
};

export { CreateLeague };
